import { render, staticRenderFns } from "./paciente.vue?vue&type=template&id=1a497fc2&"
import script from "./paciente.vue?vue&type=script&lang=js&"
export * from "./paciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports